import React from "react";
import * as moment from "moment";
import { Text, Icon } from "components/commons";
import lang from "translations";

const TimezoneNote = () => (
  <div className="bg-pelorous-lightest rounded p-sm flex items-center gap-2 mt-md">
    <Icon name="info1" fontSize="14px" className="text-pelorous-dark" />
    <Text size="text-xs" color="text-pelorous-dark">
      {lang.allTimesLocal} {moment().format("Z")})
    </Text>
  </div>
);

export default TimezoneNote;
